import router from '@/router'
import { useAuthStore } from '@/stores/useAuthStore'
import { useBoostCorePermissionStore } from '@/stores/useBoostCorePermissionStore'

const POST_LOGIN_KEY = 'oidc_redirect'
const PUBLIC_PREFIXES = ['/auth/login', '/auth/logout', '/login', '/disconnected', '/oidc-callback']

function isPublicPath(path: string): boolean {
  return PUBLIC_PREFIXES.some((p) => path.startsWith(p))
}

/**
 * Save the current per-tab URL so a future re-auth can restore it.
 * First writer wins — broadcast listeners / fetch retries / router guard all
 * call this, but the URL captured at the earliest moment is the meaningful one.
 */
function rememberCurrentUrlForRestore(): void {
  if (sessionStorage.getItem(POST_LOGIN_KEY)) return
  const here = window.location.pathname + window.location.search + window.location.hash
  if (isPublicPath(here)) return
  sessionStorage.setItem(POST_LOGIN_KEY, here)
}

/**
 * Centralized "session is gone, send the user to /auth/login".
 * - Saves the current URL once (per tab) so re-auth restores it.
 * - Drops local auth state without hitting the server.
 * - SPA-navigates (no full reload).
 * - Idempotent: skips if already on a public route.
 */
export function gotoLogin(): void {
  rememberCurrentUrlForRestore()
  useAuthStore().clearLocalSession()
  useBoostCorePermissionStore().clear()
  if (isPublicPath(window.location.pathname)) return
  router.push('/auth/login')
}
